export default __webpack_public_path__ + "static/media/enseirb.a6eb7e01.jpg";